

  
const content = `# Silent Installation on MacOS

The OnData SecureFile package can be deployed to MacOS machines using the Apple Business Manager (ABM) or other Mobile Device Management (MDM) tools such as 
Microsoft Intune. Such tools can be used to automatically deploy and manage the OnData SecureFile application. Please follow tool specific documentation on how 
to deploy the OnData SecureFile package to MacOS computers.  
  
After the SecureFile application is installed the first time, you may run the registration using script file. The following command can be used to silently 
register the SecureFile client.  
  
\`/Applications/OnData&bsol; SecureFile.app/Contents/MacOS/OnData&bsol; SecureFile -register <registration_code>\`  
  
The \`<registration_code>\` must be an active registration code obtained from the OnData Portal. For details on how to obtain a new registration code from 
the OnData Portal, please refer to the instructions in [**Register SecureFile**](reference_doc#securefile/installation_and_configuration/register_securefile).  
  
  `
  
export default content;
